import React from "react";
import { useTranslation } from 'react-i18next';

const LinearProgressChart = ({ total, used, category,remaining,accumulatorType,currencySymbol, unlimited}) => {
  debugger;
  const toAmount = (val) => {
    if (val == null) return 0;
    if (typeof val === "number") return val;
    const cleaned = String(val).replace(/[^\d.]/g, "");
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  };
  const numericTotal = toAmount(total);
  const numericUsed = toAmount(used);
  const numericRemaining = toAmount(remaining);
  const percentageUsed = numericTotal ? (numericUsed / numericTotal) * 100 : 0;
  const { t } = useTranslation();

  return (
    <div className="linear-progress-bar-wrapper">

      {/* Top Block with Magenta Background */}
      <div className="linear-progress-bar-header">
        {/* Used Amount */}
        <div className="linear-progress-bar-used-amount">
          {remaining.toLocaleString()}
        </div>
    
        {/* Total Amount and Description */}
        <div className="linear-progress-bar-description">
          {total.toLocaleString()} {t('combinedlifetime')}
        </div>
      </div>

      {/* Bottom Block with White Background */}
      <div className="linear-progress-bar-footer">
        {/* Category Name */}
        <div className="linear-progress-bar-category">
          {category}
        </div>

        <div className="total-usage-highmark-option">
          <span>{currencySymbol}{used.toLocaleString()} </span> of {currencySymbol}{total.toLocaleString()} spent
        </div>

        {/* Progress Bar */}
        <div
          style={{
            width: "100%",
            height: "12px",
            borderRadius: "6px",
            backgroundColor: "#e0e0e0",
            overflow: "hidden",
            marginBottom: "16px",
          }}
        >
          <div
            style={{
              width: `${percentageUsed}%`,
              height: "100%",
              backgroundColor: "#e70084", // Magenta progress
            }}
            className="linear-progress-bar-progress"
          ></div>
        </div>

        <div className="amount-left-highmark-option">
          {currencySymbol}{remaining.toLocaleString()} left
        </div>

        {/* Usage Details */}
        { !unlimited && (
        <div className="linear-progress-bar-usage-details">
          <span>{t('totaluseage')}</span>
          <span style={{ fontWeight: "bold" }}>
            {currencySymbol}{(numericTotal - numericRemaining).toLocaleString()}
          </span>
        </div>
  )}
      </div>
      
    </div>
  );
};

export default LinearProgressChart;
